import { SET_CAPACITY_ALL, SET_PROFILE_DETAILS, SET_CAPACITY_SELECTED_DETAILS, IS_OFFICE_STATE_SELECTED, IS_CORRESPONDENCE_STATE_SELECTED } from './types';

const initialdashboardState = {

}

const dashboardReducer = (state = initialdashboardState, action) => {
    if (action.type) {
        switch (action.type) {
            case SET_CAPACITY_ALL:
                return {
                    ...state,
                    ...action.payload
                }
            case SET_PROFILE_DETAILS:
                return {
                    ...state,
                    profileDetails: action.payload
                }
            case SET_CAPACITY_SELECTED_DETAILS:
                return {
                    ...state,
                    selectedCapacityData: action.payload
                }
                case IS_OFFICE_STATE_SELECTED:
                return {
                    ...state,
                    officeCities: action.payload
                }
                case IS_CORRESPONDENCE_STATE_SELECTED:
                return {
                    ...state,
                    correspondenceCities: action.payload
                }
            default:
                {
                    return state;
                }
        }
    }
}

export default dashboardReducer;